import React from 'react';
import { Typography, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import { ExclamationCircleFilled } from '@ant-design/icons';

const { useBreakpoint } = Grid;
const { Text } = Typography;

const MicrophoneError = ({ type = null, titleOnly = false }) => {
	const screens = useBreakpoint();
	const { t } = useTranslation();

	const getErrorMessages = (type) => {
		switch (type) {
			case 'mic_muted':
				return {
					message: t('session_recorder.errors.mic_muted'),
					title: t('session_recorder.errors.mic_muted_title'),
					type: 'warning',
				};
			case 'silence':
				return {
					message: t('session_recorder.errors.silence'),
					title: t('session_recorder.errors.silence_title'),
					type: 'warning',
				};
			default:
				return null;
		}
	};

	const errorMessages = getErrorMessages(type);
	if (!errorMessages) return null;

	if (titleOnly) {
		return (
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					background: '#fffbe6',
					borderRadius: 6,
					padding: '4px 6px',
					fontSize: 13,
					color: '#ad6800',
					minHeight: 28,
					maxWidth: 500,
					overflow: 'hidden',
					whiteSpace: 'nowrap',
					textOverflow: 'ellipsis',
					margin: '0 auto',
				}}
				title={errorMessages.title}
			>
				<ExclamationCircleFilled style={{ color: '#faad14', fontSize: 16, marginRight: 8, flexShrink: 0 }} />
				<span style={{ fontSize: 16, fontWeight: 600 }}>{errorMessages.title}</span>
			</div>
		);
	}

	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				background: '#fffbe6',
				borderRadius: 6,
				padding: '6px 12px 6px 12px',
				fontSize: 13,
				color: '#ad6800',
				minHeight: 28,
				overflow: 'hidden',
				whiteSpace: 'nowrap',
				textOverflow: 'ellipsis',
				margin: '0 auto',
			}}
			title={errorMessages.message}
		>
			<ExclamationCircleFilled style={{ color: '#faad14', fontSize: 18, marginRight: 8, flexShrink: 0 }} />
			<span style={{ fontSize: 16, marginRight: 8, fontWeight: 600 }}>{errorMessages.title}</span>
			<Text type="secondary" style={{ fontSize: 16 }}>{errorMessages.message}</Text>

		</div>
	);
};

export default MicrophoneError;
